var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _c(
        "el-card",
        { staticClass: "box-card" },
        [
          _c(
            "div",
            {
              staticClass: "clearfix",
              attrs: { slot: "header" },
              slot: "header",
            },
            [
              _c(
                "div",
                { staticClass: "card-header" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { size: "small", icon: "el-icon-back" },
                      on: { click: _vm.goBack },
                    },
                    [_vm._v("返回")]
                  ),
                  _vm._v(" "),
                  _c("span", { staticClass: "title" }, [_vm._v("商品详情")]),
                ],
                1
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "el-form",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.fullscreenLoading,
                  expression: "fullscreenLoading",
                },
              ],
              ref: "formValidate",
              staticClass: "formValidate mt20",
              attrs: { model: _vm.formValidate, "label-width": "120px" },
            },
            [
              _c(
                "el-row",
                { attrs: { gutter: 12 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-card",
                        {
                          staticClass: "section-card",
                          attrs: { shadow: "never" },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "section-header",
                              attrs: { slot: "header" },
                              slot: "header",
                            },
                            [_c("span", [_vm._v("基本信息")])]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-row",
                            { attrs: { gutter: 12 } },
                            [
                              _c(
                                "el-col",
                                _vm._b({}, "el-col", _vm.grid2, false),
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "商品名称：" } },
                                    [
                                      _c(
                                        "span",
                                        { staticClass: "form-value" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.formValidate.storeName || "无"
                                            )
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "el-col",
                                _vm._b({}, "el-col", _vm.grid2, false),
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "商品分类：" } },
                                    [
                                      _c(
                                        "span",
                                        { staticClass: "form-value" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.formatCateIds(
                                                _vm.formValidate.cateIds
                                              ) || "无"
                                            )
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "el-col",
                                _vm._b({}, "el-col", _vm.grid2, false),
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label:
                                          _vm.customConfig.mallType == 1
                                            ? "商品关键字"
                                            : "打印纸张",
                                      },
                                    },
                                    [
                                      _c(
                                        "span",
                                        { staticClass: "form-value" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.formValidate.keyword || "无"
                                            )
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _vm.customConfig.mallType == 1
                                ? _c(
                                    "el-col",
                                    _vm._b({}, "el-col", _vm.grid2, false),
                                    [
                                      _c(
                                        "el-form-item",
                                        { attrs: { label: "单位：" } },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "form-value" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.formValidate.unitName ||
                                                    "无"
                                                )
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.customConfig.mallType == 1
                                ? _c(
                                    "el-col",
                                    _vm._b({}, "el-col", _vm.grid2, false),
                                    [
                                      _c(
                                        "el-form-item",
                                        { attrs: { label: "商品简介：" } },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "form-value" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.formValidate.storeInfo ||
                                                    "无"
                                                )
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "el-col",
                                _vm._b({}, "el-col", _vm.grid2, false),
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "运费模板：" } },
                                    [
                                      _c(
                                        "span",
                                        { staticClass: "form-value" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.formatTempId(
                                                _vm.formValidate.tempId
                                              ) || "无"
                                            )
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _vm.customConfig.mallType == 1
                                ? _c(
                                    "el-col",
                                    _vm._b({}, "el-col", _vm.grid2, false),
                                    [
                                      _c(
                                        "el-form-item",
                                        { attrs: { label: "商品规格：" } },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "form-value" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.formValidate.specType
                                                    ? "多规格"
                                                    : "单规格"
                                                )
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-card",
                        {
                          staticClass: "section-card",
                          attrs: { shadow: "never" },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "section-header",
                              attrs: { slot: "header" },
                              slot: "header",
                            },
                            [_c("span", [_vm._v("规格信息")])]
                          ),
                          _vm._v(" "),
                          _vm.formValidate.specType === false
                            ? _c(
                                "el-form-item",
                                [
                                  _c(
                                    "el-table",
                                    {
                                      staticClass: "tabNumWidth",
                                      attrs: {
                                        border: true,
                                        data: _vm.OneattrValue,
                                        border: "",
                                        size: "mini",
                                      },
                                    },
                                    [
                                      _vm.customConfig.mallType == 1
                                        ? _c("el-table-column", {
                                            attrs: {
                                              align: "center",
                                              label: "图片",
                                              "min-width": "40",
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "default",
                                                  fn: function (scope) {
                                                    return [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "pictrue-view tabPic",
                                                        },
                                                        [
                                                          scope.row.image
                                                            ? _c("img", {
                                                                staticStyle: {
                                                                  width: "40px",
                                                                  height:
                                                                    "40px",
                                                                  "object-fit":
                                                                    "cover",
                                                                },
                                                                attrs: {
                                                                  src: scope.row
                                                                    .image,
                                                                },
                                                              })
                                                            : _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "empty-img",
                                                                },
                                                                [_vm._v("无")]
                                                              ),
                                                        ]
                                                      ),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              false,
                                              4159236908
                                            ),
                                          })
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.bizType == 2
                                        ? [
                                            _c("el-table-column", {
                                              attrs: {
                                                align: "center",
                                                label: "兑换积分现价",
                                                "min-width": "120",
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function (scope) {
                                                      return [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "form-value",
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                scope.row
                                                                  .pointsPrice ||
                                                                  0
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                false,
                                                4141579378
                                              ),
                                            }),
                                            _vm._v(" "),
                                            _c("el-table-column", {
                                              attrs: {
                                                align: "center",
                                                label: "兑换积分原价",
                                                "min-width": "120",
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function (scope) {
                                                      return [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "form-value",
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                scope.row
                                                                  .pointsOtPrice ||
                                                                  0
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                false,
                                                3751722185
                                              ),
                                            }),
                                          ]
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm._l(
                                        _vm.attrValue,
                                        function (item, iii) {
                                          return _c(
                                            "el-table-column",
                                            {
                                              key: iii,
                                              attrs: {
                                                align: "center",
                                                "min-width": "120",
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function (scope) {
                                                      return [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "form-value",
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                scope.row[
                                                                  iii
                                                                ] || 0
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                true
                                              ),
                                            },
                                            [
                                              _c(
                                                "template",
                                                { slot: "header" },
                                                [
                                                  _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.formThead[iii].title
                                                      )
                                                    ),
                                                  ]),
                                                ]
                                              ),
                                            ],
                                            2
                                          )
                                        }
                                      ),
                                      _vm._v(" "),
                                      _vm.formValidate.isSub && _vm.bizType == 1
                                        ? [
                                            _c("el-table-column", {
                                              attrs: {
                                                align: "center",
                                                label: "一级返佣(元)",
                                                "min-width": "120",
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function (scope) {
                                                      return [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "form-value",
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                scope.row
                                                                  .brokerage ||
                                                                  0
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                false,
                                                2315735072
                                              ),
                                            }),
                                            _vm._v(" "),
                                            _c("el-table-column", {
                                              attrs: {
                                                align: "center",
                                                label: "二级返佣(元)",
                                                "min-width": "120",
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function (scope) {
                                                      return [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "form-value",
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                scope.row
                                                                  .brokerageTwo ||
                                                                  0
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                false,
                                                1377681100
                                              ),
                                            }),
                                          ]
                                        : _vm._e(),
                                    ],
                                    2
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.formValidate.attr.length > 0 &&
                          _vm.formValidate.specType
                            ? _c(
                                "el-form-item",
                                {
                                  staticClass: "labeltop",
                                  attrs: { label: "商品属性：" },
                                },
                                [
                                  _c(
                                    "el-table",
                                    {
                                      staticClass: "tabNumWidth",
                                      attrs: {
                                        border: true,
                                        data: _vm.ManyAttrValue,
                                        border: "",
                                        size: "mini",
                                      },
                                    },
                                    [
                                      _vm.manyTabDate
                                        ? _vm._l(
                                            _vm.manyTabDate,
                                            function (item, iii) {
                                              return _c("el-table-column", {
                                                key: iii,
                                                attrs: {
                                                  align: "center",
                                                  label:
                                                    _vm.manyTabTit[iii].title,
                                                  "min-width": "80",
                                                },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "default",
                                                      fn: function (scope) {
                                                        return [
                                                          _c("span", {
                                                            staticClass:
                                                              "form-value",
                                                            domProps: {
                                                              textContent:
                                                                _vm._s(
                                                                  scope.row[iii]
                                                                ),
                                                            },
                                                          }),
                                                        ]
                                                      },
                                                    },
                                                  ],
                                                  null,
                                                  true
                                                ),
                                              })
                                            }
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.customConfig.mallType == 1
                                        ? _c("el-table-column", {
                                            attrs: {
                                              align: "center",
                                              label: "图片",
                                              "min-width": "40",
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "default",
                                                  fn: function (scope) {
                                                    return [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "pictrue-view tabPic",
                                                        },
                                                        [
                                                          scope.row.image
                                                            ? _c("img", {
                                                                staticStyle: {
                                                                  width: "40px",
                                                                  height:
                                                                    "40px",
                                                                  "object-fit":
                                                                    "cover",
                                                                },
                                                                attrs: {
                                                                  src: scope.row
                                                                    .image,
                                                                },
                                                              })
                                                            : _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "empty-img",
                                                                },
                                                                [_vm._v("无")]
                                                              ),
                                                        ]
                                                      ),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              false,
                                              4159236908
                                            ),
                                          })
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.bizType == 2
                                        ? [
                                            _c("el-table-column", {
                                              attrs: {
                                                align: "center",
                                                label: "兑换积分现价",
                                                "min-width": "120",
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function (scope) {
                                                      return [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "form-value",
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                scope.row
                                                                  .pointsPrice ||
                                                                  0
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                false,
                                                4141579378
                                              ),
                                            }),
                                            _vm._v(" "),
                                            _c("el-table-column", {
                                              attrs: {
                                                align: "center",
                                                label: "兑换积分原价",
                                                "min-width": "120",
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function (scope) {
                                                      return [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "form-value",
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                scope.row
                                                                  .pointsOtPrice ||
                                                                  0
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                false,
                                                3751722185
                                              ),
                                            }),
                                          ]
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm._l(
                                        _vm.attrValue,
                                        function (item, iii) {
                                          return _c(
                                            "el-table-column",
                                            {
                                              key: iii,
                                              attrs: {
                                                align: "center",
                                                "min-width": "120",
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function (scope) {
                                                      return [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "form-value",
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                scope.row[
                                                                  iii
                                                                ] || 0
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                true
                                              ),
                                            },
                                            [
                                              _c(
                                                "template",
                                                { slot: "header" },
                                                [
                                                  _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.formThead[iii].title
                                                      )
                                                    ),
                                                  ]),
                                                ]
                                              ),
                                            ],
                                            2
                                          )
                                        }
                                      ),
                                      _vm._v(" "),
                                      _vm.formValidate.isSub && _vm.bizType == 1
                                        ? _c("el-table-column", {
                                            attrs: {
                                              align: "center",
                                              label: "一级返佣(元)",
                                              "min-width": "120",
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "default",
                                                  fn: function (scope) {
                                                    return [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "form-value",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              scope.row
                                                                .brokerage || 0
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              false,
                                              2315735072
                                            ),
                                          })
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.formValidate.isSub && _vm.bizType == 1
                                        ? _c("el-table-column", {
                                            attrs: {
                                              align: "center",
                                              label: "二级返佣(元)",
                                              "min-width": "120",
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "default",
                                                  fn: function (scope) {
                                                    return [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "form-value",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              scope.row
                                                                .brokerageTwo ||
                                                                0
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              false,
                                              1377681100
                                            ),
                                          })
                                        : _vm._e(),
                                    ],
                                    2
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-card",
                        {
                          staticClass: "section-card",
                          attrs: { shadow: "never" },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "section-header",
                              attrs: { slot: "header" },
                              slot: "header",
                            },
                            [_c("span", [_vm._v("其他设置")])]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-row",
                            { attrs: { gutter: 12 } },
                            [
                              _c(
                                "el-col",
                                _vm._b({}, "el-col", _vm.grid, false),
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "排序：" } },
                                    [
                                      _c(
                                        "span",
                                        { staticClass: "form-value" },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.formValidate.sort || 0)
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _vm.customConfig.enableGoodsPoints == 1
                                ? _c(
                                    "el-col",
                                    _vm._b({}, "el-col", _vm.grid, false),
                                    [
                                      _c(
                                        "el-form-item",
                                        { attrs: { label: "积分：" } },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "form-value" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.formValidate
                                                    .giveIntegral || 0
                                                )
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "el-col",
                                _vm._b({}, "el-col", _vm.grid, false),
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "虚拟销量：" } },
                                    [
                                      _c(
                                        "span",
                                        { staticClass: "form-value" },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.formValidate.ficti || 0)
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "el-col",
                                { attrs: { span: 24 } },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "商品推荐：" } },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "recommend-tags" },
                                        [
                                          _vm._l(
                                            _vm.activeRecommends,
                                            function (item) {
                                              return _c(
                                                "el-tag",
                                                {
                                                  key: item.value,
                                                  staticClass: "mr10 mb5",
                                                  attrs: { type: "success" },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                      " +
                                                      _vm._s(item.name) +
                                                      "\n                    "
                                                  ),
                                                ]
                                              )
                                            }
                                          ),
                                          _vm._v(" "),
                                          _vm.activeRecommends.length === 0
                                            ? _c(
                                                "span",
                                                { staticClass: "form-value" },
                                                [_vm._v("无")]
                                              )
                                            : _vm._e(),
                                        ],
                                        2
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.customConfig.mallType == 1
                    ? _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "el-card",
                            {
                              staticClass: "section-card",
                              attrs: { shadow: "never" },
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "section-header",
                                  attrs: { slot: "header" },
                                  slot: "header",
                                },
                                [_c("span", [_vm._v("商品图片")])]
                              ),
                              _vm._v(" "),
                              _c(
                                "el-row",
                                { attrs: { gutter: 12 } },
                                [
                                  _c(
                                    "el-col",
                                    _vm._b({}, "el-col", _vm.grid2, false),
                                    [
                                      _c(
                                        "el-form-item",
                                        { attrs: { label: "商品封面图：" } },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "pictrue-view",
                                              staticStyle: { height: "375px" },
                                            },
                                            [
                                              _vm.formValidate.image
                                                ? _c("img", {
                                                    staticClass: "cover-img",
                                                    attrs: {
                                                      src: _vm.formValidate
                                                        .image,
                                                    },
                                                  })
                                                : _c(
                                                    "div",
                                                    {
                                                      staticClass: "empty-img",
                                                    },
                                                    [_vm._v("暂无图片")]
                                                  ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "el-col",
                                    { attrs: { span: 24 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        { attrs: { label: "商品轮播图：" } },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "slider-container" },
                                            [
                                              _vm.formValidate.sliderImages
                                                .length > 0
                                                ? _c(
                                                    "el-carousel",
                                                    {
                                                      staticStyle: {
                                                        width: "375px",
                                                      },
                                                      attrs: {
                                                        interval: 4000,
                                                        height: "300px",
                                                        autoplay: "autoplay",
                                                        "indicator-position":
                                                          "outside",
                                                      },
                                                    },
                                                    _vm._l(
                                                      _vm.formValidate
                                                        .sliderImages,
                                                      function (item, index) {
                                                        return _c(
                                                          "el-carousel-item",
                                                          { key: index },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "carousel-image-container",
                                                              },
                                                              [
                                                                _c("img", {
                                                                  staticClass:
                                                                    "carousel-img",
                                                                  staticStyle: {
                                                                    height:
                                                                      "375px",
                                                                    width:
                                                                      "375px",
                                                                    "object-fit":
                                                                      "cover",
                                                                  },
                                                                  attrs: {
                                                                    src: item,
                                                                    alt:
                                                                      "轮播图" +
                                                                      (index +
                                                                        1),
                                                                  },
                                                                }),
                                                              ]
                                                            ),
                                                          ]
                                                        )
                                                      }
                                                    ),
                                                    1
                                                  )
                                                : _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "empty-slider",
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                      暂无轮播图\n                    "
                                                      ),
                                                    ]
                                                  ),
                                            ],
                                            1
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.customConfig.mallType == 1
                    ? _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "el-card",
                            {
                              staticClass: "section-card",
                              attrs: { shadow: "never" },
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "section-header",
                                  attrs: { slot: "header" },
                                  slot: "header",
                                },
                                [_c("span", [_vm._v("商品详情")])]
                              ),
                              _vm._v(" "),
                              _c("el-form-item", [
                                _vm.formValidate.content
                                  ? _c("div", {
                                      staticClass: "product-content",
                                      domProps: {
                                        innerHTML: _vm._s(
                                          _vm.formValidate.content
                                        ),
                                      },
                                    })
                                  : _c(
                                      "div",
                                      { staticClass: "empty-content" },
                                      [_vm._v("暂无商品详情")]
                                    ),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }